import React from 'react';

export const LoginLoader = () => <span class="LoginLoader"></span>;
